<template>
    <div style="margin:0 -12px;">
        <div class="luna-header-box">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-1">
                        <br>
                        <i class="bi bi-chevron-left" onclick="window.location.href = '/setting'"></i>
                    </div>
                    <div class="col text-center" style="padding-top: 25px;">
                        <h5>募集のON/OFF</h5>
                    </div>
                    <div class="col-1">
                    </div>
                </div>
            </div>
        </div>
        <div class="wrap">
            <br />
            <div class="container" style="margin-top:30px;">
                <br>
                <br>
                <div class="row">
                    <div class="col-1">
                    </div>
                    <div class="col">
                        募集のON/OFF
                    </div>
                    <div class="col-1">
                        <div class="form-check form-switch">
                            <input class="form-check-input" type="checkbox" v-model="user.is_search_view"
                                v-on:change="setUsers()">
                        </div>
                    </div>
                    <div class="col-1">
                    </div>
                </div>
                <br />
                <div class="row">
                    <div class="col-1"></div>
                    <div class="col">
                        <div class="card" style="background-color: #f2f4f5">
                            <div class="card-body">
                                <div style="font-size: 16px; padding: 8px">
                                    <b>
                                        OFFにすると、相手から「いいね」を押されることがなくなります。<br>
                                        ただし、自分からはいいねを押してありがとうを返してもらうことはできます。
                                    </b>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-1"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            user: [],
        };
    },
    methods: {
        async fetchUsers() {
            let response = await axios.get("/api/user/status")
                .then((response) => {
                    this.user = response.data.user
                })
                .catch((error) => {
                    if (error.response && error.response.status == 401) {
                        window.location.href = "/auth?logout=true"
                    }
                    else {
                        this.$showErrorToast('ユーザーの取得に失敗しました。')
                    }
                })
        },
        async setUsers() {
            let response = await axios
                .post("/api/user/mod", {
                    user: this.user,
                    type: "30",
                })
                .then((response) => {
                })
                .catch((error) => {
                    if (error.response && error.response.status == 401) {
                        window.location.href = "/auth?logout=true"
                    }
                    else {
                        this.$showErrorToast('ユーザー情報の編集に失敗しました。')
                    }
                })
        },
    },
    async created() {

        // 自動ログインチェック
        var arr = new Array();
        if (document.cookie != '') {
            var tmp = document.cookie.split('; ');
            for (var i = 0; i < tmp.length; i++) {
                var data = tmp[i].split('=');
                arr[data[0]] = decodeURIComponent(data[1]);
            }

            if (arr['uid'] != undefined) {
                await axios.get("/api/user/auth/" + arr['uid'])
                    .then(
                        (response) => {
                            this.fetchUsers()
                        })
                    .catch(function (error) {
                        this.$showErrorToast('ユーザーの取得に失敗しました。')
                    })
            }
            else {
                this.fetchUsers()
            }
        }
        else {
            this.fetchUsers()
        }
    },
};
</script>
<style>
.form-switch .form-check-input {
    width: 4em;
    margin-left: -5.0em;
    margin-top: -0.5em;
}

.form-check-input {
    height: 2em;
}

.form-check-input:checked {
    background-color: #6B4EFF;
    border-color: #6B4EFF;
}
</style>
